'use strict'

JUICE_PROGRAM_ID = '08e634b4-bf92-4b34-8ec4-a5688591db64'
DESKTOP_FF_NAME = 'show_juice_program_desktop'
TOUCH_FF_NAME = 'show_juice_program_touch'
JUICE_CLIENT_PROPERTIES = ['isJuiceProgramEnabled', 'juiceProgramEndTime', 'juiceProgramStartTime']
TIMER_ADJUST_MINUTES = 5

module.exports = {
  JUICE_PROGRAM_ID,
  DESKTOP_FF_NAME,
  TOUCH_FF_NAME,
  JUICE_CLIENT_PROPERTIES,
  TIMER_ADJUST_MINUTES
}
